import React from 'react';

const ShadowColor = "#333";

const TitleShadow = {
    textShadow: `0 0 25px ${ShadowColor}`,
    padding: 50,
    margin: -50
};

const TitleAreaStyles = {
    title: {
        lineHeight: 1.25,
        marginBottom: 20,
        color: 'white',
        fontWeight: 600,
        maxWidth: '100%',
        textAlign: 'center',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        fontFamily: 'inherit',
        textShadow: `0 0 25px ${ShadowColor}`,
        display: '-webkit-box',
        WebkitLineClamp: 4,
        WebkitBoxOrient: 'vertical'
    },
    tagline: {
        color: 'white',
        fontFamily: 'inherit',
        textAlign: 'center',
        ...TitleShadow
    },
    titleContainer: {
        fontFamily: 'Poppins, sans-serif',
        gridColumn: 1,
        gridRow: 1,
        zIndex: 10,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        lineHeight: 'normal',
        flexDirection: 'column',
        padding: 10,
        boxSizing: 'border-box'
    }
};

function listify(xs, and = '&') {
    if (xs.length === 0) return null;
    let init = xs.slice(0, xs.length - 1); // get all but the last;
    let last = xs[xs.length - 1];
    return init.map(x => x + ", ").join('') + (init.length > 1 ? and + ' ' : '') + last;
}

const selector = ({is, webpage_title, posts, plurality, measurements, included_terms, included_from_taxonomy, kept_title, loadingReplacement}) => {
    let title = null;
    let tagline = null;
    let terms = null;
    if (is['404'] && posts.length === 0) {
        title = 'Not Found';
    } else if (!is.front_page) {
        if (kept_title && !(plurality && plurality.by === 'term' && plurality.terms.filter(({taxonomy:{name}}) => name === 'industries'))) {
            title = webpage_title;
        } else if (is && is.singular) {
            title = posts[0].title;
            if (posts[0].post_type.name === 'client') {
                let industries = posts[0].taxonomies.industries.map(x => x.name);
                tagline = listify(industries);
            } else if (posts[0].post_type.name === 'post') {
                tagline = posts[0].post_date;
            }
        } else if (plurality && plurality.terms) {
            title = listify(plurality.terms.map(x => x.name));
            tagline = plurality.terms.length === 1 ? plurality.terms[0].description : null;
        } else if (plurality && plurality.taxonomy) {
            title = plurality.taxonomy.labels.name;
        } else if (is && !is.singular && plurality.post_types) {
            title = listify(Object.values(plurality.post_types).map(x => x.labels.name));
        }
    }

    if (included_from_taxonomy) {
        terms = included_terms;
    }

    return {
        height: measurements.title_area_featured_media_height,
        title,
        tagline,
        terms,
        loadingReplacement
    };
};

export const TitleArea = ({style}) => {
    const {tagline, title, height, terms, loadingReplacement} = polyphony.useState(selector);
    const matching = polyphony.hooks.useFeaturedMedia();
    const {Image, Video} = polyphony.components.generic;

    const vaURL = new URL(window.location.href);
    vaURL.searchParams.delete('override__taxonomy');
    vaURL.searchParams.delete('override__term');

    return (
        <div className="title_area" style={{display: 'grid', gridTemplateColumns: "100%", gridTemplateRows: "100%", height, overflow: 'hidden', ...style}}>
            <div style={{background: 'black', gridColumn: 1, gridRow: 1, zIndex: -3, height: '100%', width: '100%' }}>
                {!loadingReplacement && matching && matching.type === 'image' && <Image key="feat-image" media={matching} style={{objectFit: 'cover', width: "100%", height: "100%"}} />}
                {!loadingReplacement && matching && matching.type === 'video' && <Video key="feat-video" src={matching.url} mimeType={matching.mimeType} style={{objectFit: 'cover', width: "100%", height: "100%"}} autoplay />}
            </div>
            <div style={{gridColumn: 1, gridRow: 1, zIndex: -2, height: '100%', width: '100%', background: `linear-gradient(${ShadowColor} 0%, transparent 30%)`, overflow: 'hidden'}} />
            <div style={{...TitleAreaStyles.titleContainer, zIndex: -1}}>
                {!loadingReplacement && <div style={TitleShadow}><h1 style={{...TitleAreaStyles.title, fontSize: 'min(max(8vw, 45px), 65px)'}}>{title}</h1></div>}
                {!loadingReplacement && <h3 style={{...TitleAreaStyles.tagline, fontSize: `max(calc(65px * .75), 1.66rem)`}}>{tagline}</h3>}
                {loadingReplacement && <h1 style={{...TitleAreaStyles.title, fontSize: 65}}>...</h1>}
            </div>
            <div style={{gridColumn: 1, gridRow: 1, height: '100%', width: '100%', display: 'flex', flexFlow: 'column nowrap', justifyContent: 'flex-end'}}>
                <div style={{display: 'flex', flexFlow: 'row wrap', justifyContent: 'center', marginBottom: 10}}>
                {terms && <a style={{textShadow: `0 0 10px ${ShadowColor}`, cursor: 'pointer', color: 'white', padding: 10, textAlign: 'center'}} href={vaURL.toString()} data-behavior='replace'>View All</a>}
                {terms && terms.map(({id, name, slug}) => {
                     const url = new URL(window.location.href);
                     url.searchParams.set('override__taxonomy', 'industries');
                     url.searchParams.set('override__term', slug);
                     return <a data-behavior='replace' href={url.toString()} key={id} style={{textShadow: `0 0 10px ${ShadowColor}`, cursor: 'pointer', color: 'white', padding: 10, textAlign: 'center'}}>{name}</a>;
                 })}
                </div>
            </div>
        </div>
    );
};

export default TitleArea;

